/**
 * Orchestration Module
 *
 * Frontend module for the AI orchestration system.
 * Provides services, hooks, and types for multi-agent research workflows.
 */

import { type Framework } from '@toeverything/infra';

import { DefaultServerService } from '../cloud';
import { WorkspaceScope } from '../workspace';
import { OrchestrationService } from './services/orchestration-service';

export * from './hooks';
export * from './services';
export * from './types';

/**
 * Configure the Orchestration module
 *
 * Registers the OrchestrationService with its dependencies.
 * Must be called after configureCloudModule to ensure DefaultServerService is available.
 */
export function configureOrchestrationModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(OrchestrationService, [DefaultServerService]);
}
